import Version from '@/components/Version';
import Text from '@/elements/Text';
import styled from '@/styles';

const FOOTER_HEIGHT = '82px';

const Wrapper = styled('footer', {
  alignItems: 'center',
  backgroundColor: '$neutralA4',
  display: 'flex',
  gridArea: 'footer',
  justifyContent: 'space-between',
  height: FOOTER_HEIGHT,
  padding: '0 32px',
  '@phoneOnly': {
    padding: '0 8px',
    flexDirection: 'column-reverse',
    justifyContent: 'center',
    gap: '5px',
  },
});

Wrapper.displayName = 'stitches(AppFooter.Wrapper)';

const Footer = () => {
  return (
    <Wrapper>
      <Version size="sm" />
      <Text color="lighter" size="sm">
        &copy; {new Date().getFullYear()} Gravy Workforce Technologies
      </Text>
    </Wrapper>
  );
};

export { FOOTER_HEIGHT };
export default Footer;
